export default class Base {
  constructor(data) {
    Object.assign(this, data);
    if(!data) return;
    if (typeof data.metadata === 'string') this.metadata = JSON.parse(data.metadata);
  }

  is(value) {
    return Number(value) === Number(this.id);
  }
}